module.exports = __webpack_public_path__ + "img/icon-work-3.5e270cae.svg";